import { Routes } from '@angular/router';
import { resultsGuard } from './guards/results.guard';
import { catchAllRedirectGuard } from './guards/catch-all-redirect.guard';
import { wheelGuard } from './guards/wheel.guard';
import { wheelResolver } from './pages/wheel-page/wheel.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home-page/home-page.component').then(
        (m) => m.HomePageComponent,
      ),
  },
  {
    path: 'game/:gameId',
    loadComponent: () =>
      import('./pages/game-page/game-page.component').then(
        (m) => m.GamePageComponent,
      ),
  },
  {
    path: 'game-iframe',
    loadComponent: () =>
      import('./pages/game-page-iframe/game-page-iframe.component').then(
        (m) => m.GamePageIframeComponent,
      ),
  },
  {
    path: 'wheel',
    canActivate: [wheelGuard],
    resolve: {
      wheel: wheelResolver,
    },
    loadComponent: () =>
      import('./pages/wheel-page/wheel-page.component').then(
        (m) => m.WheelPageComponent,
      ),
  },
  {
    path: 'results',
    canActivate: [resultsGuard],
    loadComponent: () =>
      import('./pages/results-page/results-page.component').then(
        (m) => m.ResultsPageComponent,
      ),
  },
  {
    path: '**',
    canActivate: [catchAllRedirectGuard],
    loadComponent: () =>
      import('./pages/home-page/home-page.component').then(
        (m) => m.HomePageComponent,
      ),
  },
];
